module.exports = __webpack_public_path__ + "908e4d2e/img/revit-icon.5ff0d581.svg";